export function extractApiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message) return err.message;
  if (typeof err === 'string' && err) return err;
  if (!err || typeof err !== 'object') return fallback;

  const record = err as Record<string, unknown>;
  const detail = record.detail;
  if (typeof detail === 'string' && detail) return detail;
  if (detail && typeof detail === 'object') {
    const detailRecord = detail as Record<string, unknown>;
    if (typeof detailRecord.detail === 'string' && detailRecord.detail) return detailRecord.detail;
    if (typeof detailRecord.error === 'string' && detailRecord.error) return detailRecord.error;
    if (typeof detailRecord.message === 'string' && detailRecord.message) return detailRecord.message;
  }
  if (typeof record.code === 'string' && record.code) return record.code;
  if (typeof record.status === 'number') return `Request failed with HTTP ${record.status}`;
  return fallback;
}
